import React from 'react';
import { LockKeyhole, BarChart3, AlertCircle } from 'lucide-react';

const PermissionEmptyState = ({
    module,
    description
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg border border-gray-200 shadow-sm h-64 w-full max-w-3xl mx-auto my-8">
      <div className="mb-2 bg-gray-100 p-4 rounded-full">
        <LockKeyhole className="text-gray-500 w-8 h-8" />
      </div>
      
      <h3 className="text-xl font-semibold text-gray-800 mb-2">
        {module} Access Restricted
      </h3>
      
      <p className="text-gray-600 text-center mb-6 max-w-md">
        {description}
    
      </p>
      
      <div className="flex items-center gap-6 text-sm text-gray-500">
        <div className="flex items-center">
          <BarChart3 className="w-4 h-4 mr-2" />
          <span>{module} Module</span>
        </div>
        <div className="flex items-center">
          <AlertCircle className="w-4 h-4 mr-2" />
          <span>Permission Required</span>
        </div>
      </div>
      
      <button className="mt-6 bg-[#3B0069] hover:bg-purple-800 text-white py-2 px-4 rounded-md transition-colors duration-200 flex items-center gap-2">
        Request Access
      </button>
    </div>
  );
};

export default PermissionEmptyState;